export const LABEL_PATH = "/label/:contents";
export const ESTIMATE_PATH = "/estimate";
export const ESTIMATE_DETAIL_PATH = "/estimate/detail/:id";
